var _defs, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew194({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.5,
    y: 4.23,
    width: 15,
    height: 7.53
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.34,9.5a1.82,1.82,0,0,0,.93.27c.53,0,.84-.28.84-.69s-.21-.59-.75-.8S3.29,7.71,3.29,7.14A1.16,1.16,0,0,1,4.6,6.05a1.78,1.78,0,0,1,.88.2l-.14.42a1.61,1.61,0,0,0-.76-.19c-.55,0-.76.33-.76.6s.24.56.8.78,1,.59,1,1.18S5.19,10.2,4.24,10.2a2.14,2.14,0,0,1-1-.26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.17,10a2.66,2.66,0,0,1-1.06.19,1.88,1.88,0,0,1-2-2,2,2,0,0,1,2.1-2.11,2.22,2.22,0,0,1,1,.18l-.13.42a2,2,0,0,0-.81-.16A1.49,1.49,0,0,0,6.67,8.14,1.46,1.46,0,0,0,8.21,9.76a2,2,0,0,0,.85-.17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.78,10.14l-1.31-4H10l.62,2c.18.54.32,1,.43,1.5h0c.12-.47.28-1,.46-1.5l.68-2h.56l-1.44,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew194);
export default __webpack_public_path__ + "static/media/Symbolpack_New_194.50ccd11bc9e8eb1d9ebce1a4746997f0.svg";
export { ForwardRef as ReactComponent };